<mat-dialog-content class="tws-w-full tws-min-h-full tws-min-w-full">
  <div
    class="tws-max-w-sm tws-w-full tws-min-w-full tws-min-h-full tws-rounded tws-overflow-hidden tws-shadow-md"
  >
    <div class="tws-w-full tws-min-h-full">
      <img class="tws-w-full" src="{{ urlFirma.url }}" alt="firma" />
    </div>
  </div>
</mat-dialog-content>
